import { Box, Typography } from "@mui/material";
import React from "react";
import Button from "../../components/controls/Button";
import { useTranslation } from "react-i18next";
import HomeIcon from "@mui/icons-material/Home";
import globalStyles from "../../style/global.js";
import useStyles from "./notFoundStyle";
import { useNavigate } from "react-router-dom";
function NotFound() {
  const globalClasses = globalStyles();
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleClick = (e) => {
    navigate("/");
  };
  return (
    <Box className={classes.box}>
      <Box>
        {" "}
        <Typography variant="h1" color="primary">
          {" "}
          404{" "}
        </Typography>{" "}
      </Box>
      <Box>
        {" "}
        <Typography variant="h4"> {t("pageNotFound")} </Typography>{" "}
      </Box>
      <Box>
        {" "}
        <Button
          className={globalClasses.btn}
          fullWidth="200px"
          variant="contained"
          color="primary"
          startIcon={<HomeIcon />}
          disabled={false}
          onClick={handleClick}
          text={t("backToHomePage")}
        />{" "}
      </Box>
    </Box>
  );
}

export default NotFound;
